import './toaster.scss';

import { CToaster } from '@coreui/react';
import React, { useCallback, useState } from 'react';

import { IToastPosition } from '../../../constants/notification';
import { IToastProps, Toast } from '../Toast/Toast';
import { ToasterContext } from './ToasterContext';

interface IToasterProps {
  children: any;
  position?: IToastPosition;
  className?: string;
  [key: string]: any;
}

export const Toaster: React.FunctionComponent<IToasterProps> = ({
  position = IToastPosition.TopRight, children, className = 'toaster', ...props
}) => {
  const [toasts, setToasts] = useState<IToastProps[]>([]);
  const addToast = useCallback(
    (toast) => {
      setToasts((toasts) => [...toasts, toast]);
    }, [setToasts]);

  return (
    <ToasterContext.Provider value={{ addToast }}>
      {children}
      <CToaster
        position={position}
        className={className}
        {...props}
      >
        {toasts.map((toast, index) => (
          <Toast {...toast} key={index} />
        ))}
      </CToaster>
    </ToasterContext.Provider>
  );
};
